/* src/app/components/shop/products/product-details/product-details.component.scss */
.p-20-0 {
  padding: 20px 0px !important;
}
.custom-size {
  width: 50%;
  height: 15%;
}
.product-title {
  color: black;
  font-size: 32px;
  font-weight: 700;
}
.product_detail_qv {
  font-size: 12px !important;
  overflow: auto;
}
.text {
  text-transform: capitalize;
}
#prod-details {
  background-color: #EBEBEB;
}
#prod-details .header {
  margin: 20px 0px 15px 0px;
  padding: 0px 10px 0px 10px;
  cursor: pointer;
}
#prod-details .main {
  width: 100%;
}
#prod-details .review-wrapper .mat-mdc-card {
  box-shadow: none !important;
  padding: 0px;
}
#prod-details .prodReview {
  margin-top: 20px !important;
}
#prod-details .prodReview .mat-expansion-panel {
  border: none !important;
  margin-bottom: 0px !important;
}
#prod-details .prodReview .mat-expansion-panel .mat-expansion-panel-header {
  padding: 0px 5px;
}
#prod-details .prodReview .mat-expansion-panel ::ng-deep .mat-expansion-panel-body {
  padding: 0px 5px !important;
  font-family: "IBM Plex Sans", sans-serif !important;
}
#prod-details .prodReview .color-f-s-13 {
  color: #797979;
  font-size: 13px;
  font-family: roboto;
  margin-top: 4px;
  margin-left: 10px;
}
#prod-details .prodBox {
  height: auto;
  width: auto;
}
#prod-details .color-f-s-14 {
  color: #5e5e5e;
  font-weight: 600;
  margin-top: 5px;
  font-size: 12px;
}
#prod-details .subscriptionButton {
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16), 0 2px 10px rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  font-size: 15px;
  padding: 4px 32px;
}
#prod-details .color-b {
  background-color: white;
}
@media only screen and (min-width: 992px) {
  #prod-details .m-left-25 {
    margin-left: 25px !important;
  }
}
#prod-details .color2-f-s-14 {
  color: #000000;
  font-size: 14px;
  font-weight: bold;
}
.product_detail_qv {
  font-size: 12px !important;
  overflow: auto;
}
::ng-deep .ngxImageZoomContainer > img {
  height: 100% !important;
  width: 100% !important;
}
::ng-deep .ngxImageZoomContainer {
  height: 441px !important;
  width: 100% !important;
  max-width: 441px;
}
@media (min-width: 100px) and (max-width: 300px) {
  ::ng-deep .ngxImageZoomContainer {
    max-height: 300px;
  }
}
@media only screen and (max-width: 768px) {
  .p-top-0 {
    padding-top: 0px !important;
  }
}
.item_options {
  display: inline-block;
  border: 1px solid #dfdfdf;
  padding: 12px 16px;
  border-radius: 37.99999px;
  margin: 4px;
}
::ng-deep .mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:hover:not([aria-disabled=true]) {
  background: none;
}
::ng-deep .mat-expansion-panel:hover .mat-expansion-indicator::after {
  color: var(--theme-deafult-secondary);
}
.bg-img img {
  width: 100%;
  height: 570px;
  object-fit: cover;
  object-position: top;
}
.p-relative {
  position: relative !important;
}
.p-absolute {
  position: absolute !important;
}
.p-abs {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}
.p-content-div {
  top: 30%;
  left: 3%;
}
.w-35 {
  width: 35%;
}
.shop-btn {
  background: white;
  border-radius: 23px;
  display: inline-block;
  padding: 15px 32px;
  cursor: pointer;
}
.shop-btn:hover {
  background-color: #cccccc;
}
.abs-width {
  width: 100%;
  left: 5%;
}
.product-button {
  margin: 20px;
  padding: 6px 32px !important;
  background-color: black !important;
  color: white !important;
}
.product-button:hover {
  background-color: #333333 !important;
}
.d-none {
  opacity: 0;
}
.w-89 {
  width: 89%;
}
.img-bg {
  flex: none !important;
  background-size: cover;
  object-fit: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.img-bg2 {
  flex: none !important;
  background-size: cover;
  object-fit: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 560px;
}
@media (min-width: 0px) and (max-width: 960px) {
  .img-bg2 {
    height: 320px !important;
  }
}
.faded-in {
  animation: fadeIn 0.6s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(16px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
.faded-out {
  animation: fadeOut 0.6s;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(16px);
  }
}
/*# sourceMappingURL=product-details.component.css.map */
